/**
 * Temporary maintenance/holding page displayed on all routes during site shutdown.
 * @returns {JSX.Element} Full-screen centered holding page with no branding.
 */
export default function MaintenancePage_Component() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6">
      <div className="text-center max-w-lg">
        <div className="mb-8">
          <div className="inline-block w-2 h-2 rounded-full bg-purple-500 animate-pulse" />
        </div>
        <h1 className="text-3xl font-light text-white tracking-wide mb-4">
          We&apos;re working on something exciting
        </h1>
        <p className="text-gray-500 text-sm tracking-widest uppercase">
          Stay tuned
        </p>
      </div>
    </div>
  );
}
